import './style.scss'
import { PAGE_URLS } from '../../constants/hrefLinks';

/*
	This component is used for the Ski/Snowboarding switch, appears in the center of the header on desktop and in search menu on mobile
*/

interface HomePageSwitchProps {
	isLandingPage: boolean
}


function HomePageSwitch({isLandingPage}: HomePageSwitchProps) {
	
	return (
		<div className="header-activity-switch-wrap">
			<button 
				className={`header-activity-switch ${isLandingPage ? 'header-activity-switch-current' : ''}`}
				onClick={isLandingPage ? undefined : () => window.location.replace('/')}
			>
				Home
			</button>
			<button 
				className={`header-activity-switch ${!isLandingPage ? 'header-activity-switch-current' : ''}`}
				onClick={isLandingPage ? () => window.location.replace(`${PAGE_URLS.SEARCH}`) : undefined}
			>
				Explore
			</button>
		</div>
	)
}

export default HomePageSwitch
